import { User, UserAuth } from '@handover/shared-types';

export const getCompanyDisplayName = (
  userAuth?: UserAuth | null,
  profile?: Partial<User> | null
): string | null => {
  const companyName = profile?.companyName || userAuth?.companyName || userAuth?.customClaims?.companyName;

  if (typeof companyName !== 'string') {
    return null;
  }

  const trimmedCompanyName = companyName.trim();
  return trimmedCompanyName ? trimmedCompanyName : null;
};
